// types
import {
  appLoadingReturnType,
  editAppDataActionReturnType,
  getAppDataActionReturnType,
  getAppDataReturnType,
  loginReturnType,
  refreshTokenReturnType,
  registrationReturnType,
  forgotPasswordReturnType,
  resetPasswordReturnType,
  appNotificationReturnType,
  appFlashMessageReturnType,
  logoutReturnType,
  appActionType,
} from '../../types/actions/app';
import {
  appDataType,
  authParamsType,
  forgotPasswordParamsType,
  flashMessageType,
  registrationParamsType,
  resetPasswordParamsType,
} from '../../types/types';
// consts
import * as types from '../constants/actionConstants';

const appAction: appActionType = {
  login(params: authParamsType, patientCallback: () => void, doctorCallback: () => void): loginReturnType {
    return {
      type: types.APP_LOGIN,
      params,
      patientCallback,
      doctorCallback,
    };
  },
  logout(callback: () => void): logoutReturnType {
    return {
      type: types.APP_LOGOUT,
      callback,
    };
  },
  registration(params: registrationParamsType, callback: () => void): registrationReturnType {
    return {
      type: types.APP_REGISTRATION,
      params,
      callback,
    };
  },
  forgotPassword(params: forgotPasswordParamsType, callback: () => void): forgotPasswordReturnType {
    return {
      type: types.APP_FORGOT_PASSWORD,
      params,
      callback,
    };
  },
  resetPassword(params: resetPasswordParamsType, callback: () => void): resetPasswordReturnType {
    return {
      type: types.APP_RESET_PASSWORD,
      params,
      callback,
    };
  },
  createToken(accessToken: string, refreshToken: string): void {
    localStorage.setItem('accessToken', accessToken);
    localStorage.setItem('refreshToken', refreshToken);
  },
  createSelfTestToken(selfTestToken: string): void {
    sessionStorage.setItem('selfTestToken', selfTestToken);
  },
  createIntegrationToken(integrationToken: string): void {
    sessionStorage.setItem('integrationToken', integrationToken);
  },
  deleteTokens(): void {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    sessionStorage.removeItem('selfTestToken');
  },
  refreshToken(refreshToken: string, callback: () => void, loginRedirect: () => void): refreshTokenReturnType {
    return {
      type: types.APP_REFRESH_TOKEN,
      refreshToken,
      callback,
      loginRedirect,
    };
  },
  appNotification(status: boolean): appNotificationReturnType {
    return {
      type: types.APP_NOTIFICATION,
      payload: { notification: status },
    };
  },
  appFlashMessage(message: string, variant: flashMessageType['variant'] = 'error'): appFlashMessageReturnType {
    return {
      type: types.APP_FLASH_MESSAGE,
      payload: {
        flashMessage: { message, variant },
      },
    };
  },
  clearFlashMessage(): appFlashMessageReturnType {
    return {
      type: types.APP_FLASH_MESSAGE,
      payload: {
        flashMessage: null,
      },
    };
  },
  appLoading(status: boolean, progress: number): appLoadingReturnType {
    const loading = {
      status: status,
      progress: progress,
    };
    return {
      type: types.APP_LOADING,
      payload: {
        loading,
      },
    };
  },
  getAppDataAction(isIntegration: boolean): getAppDataActionReturnType {
    return {
      type: types.GET_APP_DATA,
      isIntegration,
    };
  },
  getAppData(data: appDataType): getAppDataReturnType {
    return {
      type: types.APP_DATA,
      payload: { app: { ...data } },
    };
  },
  editAppDataAction(data: appDataType, isIntegration: boolean, callback?: () => void): editAppDataActionReturnType {
    return {
      type: types.EDIT_APP_DATA,
      data,
      isIntegration,
      callback,
    };
  },
};

export default appAction;
